
export default {
    name: 'ServiceCard',
    props: {
        service: {
            type: Object,
            required: true,
        },
        /**
         * Should the service card be a simplified version?
         */
        simplified: {
            type: Boolean,
            default: false,
        },
        /**
         * The route to link to (Used on landing page)
         */
        to: {
            type: Object,
            default: null,
        },
        /**
         * Is this the currently selected / active service?
         */
        active: {
            type: Boolean,
            default: false,
        },
        /**
         * Hide the icon
         */
        hideIcons: {
            type: Boolean,
            default: false,
        },
    },
};
